import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { obtenerDescripcionPago } from './helpers/mediosPago';

const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).replace(/([A-Z])/g, ' $1');

export const ObservacionModal = ({ open, onClose, observacion, pedidoNro }) => {
    let datosCli;

    try {
        datosCli =
            typeof observacion === 'string' ? JSON.parse(observacion) : observacion;
    } catch (error) {
        datosCli = null; // String mal formado
    }

    const datosGenerales = datosCli && typeof datosCli === 'object'
        ? Object.entries(datosCli).filter(([key]) => key !== 'pago')
        : [];

    const detallePago = datosCli?.pago && typeof datosCli.pago === 'object'
        ? Object.entries(datosCli.pago)
        : [];

    const renderCampo = (key, value, parentKey = '') => {
        const clave = parentKey ? `${parentKey}.${key}` : key;

        // Ocultar Tarjeta en todos los casos
        if (key === 'Tarjeta') {
            return null;
        }


        // Usar obtenerDescripcionPago para mostrar el medio de pago con tarjeta
        if (key === 'medioPago') {
            const tarjeta = datosCli?.pago?.Tarjeta;
            const descripcion = obtenerDescripcionPago(value, tarjeta);
            return (
                <Grid item xs={6} md={6} key={clave}>
                    <Typography variant="body2">
                        <strong>Medio de Pago:</strong> {descripcion}
                    </Typography>
                </Grid>
            );
        }

        // Mostrar el resto de los campos
        return (
            <Grid item xs={6} md={6} key={clave}>
                <Typography variant="body2">
                    <strong>{capitalize(key)}:</strong> {value ?? 'No disponible'}
                </Typography>
            </Grid>
        );
    };


    const contenidoModal = datosCli && typeof datosCli === 'object' && Object.keys(datosCli).length > 0 ? (
        <Box sx={{ padding: 2 }}>
            {datosGenerales.length > 0 && (
                <Box sx={{ mb: 3, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                    <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                        Datos
                    </Typography>
                    <Grid container spacing={2}>
                        {datosGenerales.map(([key, value]) => {
                            if (key === 'mercadoPago' && value === true) {
                                return (
                                    <Grid item xs={6} md={6} key={key}>
                                        <Typography variant="body2">
                                            <strong>Estado de pago:</strong> Pagado con Mercado Pago
                                        </Typography>
                                    </Grid>
                                );
                            }

                            if (typeof value === 'object' && value !== null) {
                                return Object.entries(value).map(([subKey, subValue]) =>
                                    renderCampo(subKey, subValue, key)
                                );
                            }

                            return renderCampo(key, value);
                        })}
                    </Grid>
                </Box>
            )}

            {detallePago.length > 0 && (
                <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                    <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                        Detalle del Pago
                    </Typography>
                    <Grid container spacing={2}>
                        {detallePago.map(([key, value]) => renderCampo(key, value, 'pago'))}
                    </Grid>
                </Box>
            )}
        </Box>
    ) : (
        <Typography sx={{ p: 2 }}>No hay datos para mostrar o los datos son inválidos.</Typography>
    );

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                <Typography variant="h6" fontWeight="bold">
                    {pedidoNro ? `Pedido N° ${pedidoNro}` : 'Datos'}
                </Typography>
            </DialogTitle>

            <DialogContent dividers>{contenidoModal}</DialogContent>
        </Dialog>
    );
};
